import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ProveedoresService {

  PATH = environment.API_BASE + '/Proveedores';


  constructor(
    private http: HttpClient
  ) { }

  TieneProveedoresCliente(idCliente: number): Observable<boolean> {
    const uri = this.PATH + '/TieneProveedoresCliente/' + idCliente;
    return this.http.get<boolean>(uri);
  }

  TienePermisoCambioProveedor(idProveedor: number): Observable<boolean> {
    const uri = this.PATH + '/TienePermisoCambioProveedor/' + idProveedor;
    return this.http.get<boolean>(uri);
  }

  TieneMasProveedoresCliente(idcliente: number, idProveedor: number): Observable<{ ID: number, NOMBRE: string }[]> {
    return this.http.get<{ ID: number, NOMBRE: string }[]>(
      this.PATH + '/TieneMasProveedoresCliente/' + idcliente + '/' + idProveedor
    );
  }

  ActualizarIdProveedorSolicitud(idSolicitud: number, idProveedor: number, observacionesCambio: string, situacionFinalTraza: string): Observable<any> {
    const uri = this.PATH + '/ActualizarIdProveedorSolicitud/' + idSolicitud + '/' + idProveedor + '/' + observacionesCambio + '/' + situacionFinalTraza;
    return this.http.get(uri);
  }

  ActualizarIdProveedorContenido( idContenido: number, idProveedor: number, observacionesCambio: string, situacionFinalTraza: string): Observable<any> {
    const uri = this.PATH + '/ActualizarIdProveedorContenido/' + idContenido + '/' + idProveedor + '/' + observacionesCambio + '/' + situacionFinalTraza;
    return this.http.get(uri);
  }

}
